/**
 * Backend base-URL resolution + auth header injection, shared by the chat
 * transport and the apply-draft request.
 *
 * In dev, Vite proxies /api/ai/* to http://localhost:3001. In other envs the
 * VITE_VERCEL_BACKEND_BASE_URL override is used (staging/preview/prod).
 */

import supabase from '@/shared/libs/supabase';

export const BACKEND_BASE =
  (typeof import.meta !== 'undefined' &&
    (import.meta as ImportMeta & { env: { VITE_VERCEL_BACKEND_BASE_URL?: string } }).env
      .VITE_VERCEL_BACKEND_BASE_URL) ||
  '';

export const CHAT_ENDPOINT = `${BACKEND_BASE}/api/ai/chat`;
export const APPLY_DRAFT_ENDPOINT = `${BACKEND_BASE}/api/ai/apply-draft`;
export const GENERATE_TEMPLATE_ENDPOINT = `${BACKEND_BASE}/api/ai/generate-template`;

/** Returns the current Supabase access token, or null when unauthenticated. */
export async function getAccessToken(): Promise<string | null> {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  return session?.access_token ?? null;
}

export function authHeaders(token: string | null): Record<string, string> {
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}
